import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { PaymentStatus, UpdateContractBillingRequest } from '../player-auction.type';

export interface BillingEditDialogData {
  contractLabel: string;
  fee: number;
  payment_status: PaymentStatus;
}

@Component({
  selector: 'app-billing-edit-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
  ],
  templateUrl: './billing-edit-dialog.html',
  styleUrl: './billing-edit-dialog.scss',
})
export class BillingEditDialog {
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<BillingEditDialog>);
  readonly data = inject<BillingEditDialogData>(MAT_DIALOG_DATA);

  form: FormGroup = this.fb.group({
    fee: [this.data.fee, [Validators.required, Validators.min(0), Validators.max(10000000)]],
    payment_status: [this.data.payment_status, [Validators.required]],
  });

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const request: UpdateContractBillingRequest = this.form.value;
    this.dialogRef.close(request);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  getErrorMessage(field: string): string {
    const c = this.form.get(field);
    if (!c) return '';
    if (c.hasError('required')) return 'This field is required';
    if (c.hasError('min')) return `Minimum value is ${c.errors?.['min'].min}`;
    if (c.hasError('max')) return `Maximum value is ${c.errors?.['max'].max}`;
    return '';
  }
}
